import Appliance from "../../parts/appliance";

/**
 * @returns array
 * */
const getHoodConditions = (cabinetParent, forCrownMolding = false) => {
  let conditions = [];
  const applianceParent = cabinetParent.layout.parts[Appliance.id];
  const hoodIsVisible = applianceParent && applianceParent.hood && applianceParent.hood.activeFeature && !applianceParent.hood.disabled;
  if (!forCrownMolding) {
    const microwaveIsVisible = applianceParent && applianceParent.microwave && applianceParent.microwave.activeFeature && !applianceParent.microwave.disabled;
    conditions.push({
      propName: "Hood",
      propValue: hoodIsVisible || ((cabinetParent.layout.type === 6) && microwaveIsVisible) ? "H" : "C"
    });
    if (hoodIsVisible && applianceParent.hood.activeFeature.metaData["Width"]) {
      conditions.push({
        propName: "Width",
        propValue: applianceParent.hood.activeFeature.metaData["Width"]
      });
    } else if (microwaveIsVisible && applianceParent.microwave.activeFeature.metaData["Width"]) {
      conditions.push({
        propName: "Width",
        propValue: applianceParent.microwave.activeFeature.metaData["Width"]
      });
    }
  }
  if (hoodIsVisible && applianceParent.hood.activeFeature.metaData["HoodHeight"]) {
    conditions.push({
      propName: "HoodHeight",
      propValue: applianceParent.hood.activeFeature.metaData["HoodHeight"]
    });
  }
  return conditions
}

export default getHoodConditions
